var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyOrg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 287,
    viewBox: "0 0 350 287",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1048 75.8616C-22.4153 143.33 53.3732 203.515 98.4574 225.173C161.713 255.562 295.927 268.952 330.768 175.68C369.464 72.0887 107.005 -8.47343 35.1048 75.8616Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.172 88.7559H91.3535V185.847H257.172V88.7559Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.3535,
    y: 97.4082,
    width: 37.0997,
    height: 88.3006,
    fill: "#BABABB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5215,
    y: 109.459,
    width: 23.5402,
    height: 3.44826,
    rx: 1.72413,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5215,
    y: 115.494,
    width: 16.8614,
    height: 3.44826,
    rx: 1.72413,
    fill: "#C2C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5215,
    y: 121.529,
    width: 21.2409,
    height: 3.44826,
    rx: 1.72413,
    fill: "#DBDBDB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5215,
    y: 127.557,
    width: 15.3285,
    height: 3.44826,
    rx: 1.72413,
    fill: "#C0C0C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5215,
    y: 133.592,
    width: 23.5402,
    height: 3.44826,
    rx: 1.72413,
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.252 88.6816H91.3535V99.5011H257.252V88.6816Z",
    fill: "#BABABB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9298 95.9021C98.933 95.9021 99.7462 95.0911 99.7462 94.0907C99.7462 93.0903 98.933 92.2793 97.9298 92.2793C96.9265 92.2793 96.1133 93.0903 96.1133 94.0907C96.1133 95.0911 96.9265 95.9021 97.9298 95.9021Z",
    fill: "#EB5757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.449 94.0755C105.45 94.4339 105.344 94.7844 105.145 95.0828C104.946 95.3811 104.662 95.6138 104.33 95.7515C103.999 95.8891 103.633 95.9255 103.281 95.856C102.928 95.7865 102.604 95.6142 102.35 95.361C102.095 95.1078 101.922 94.7851 101.852 94.4336C101.781 94.0822 101.817 93.7178 101.954 93.3866C102.092 93.0554 102.325 92.7723 102.623 92.5731C102.922 92.3739 103.273 92.2676 103.633 92.2676C104.114 92.2676 104.576 92.4579 104.916 92.7969C105.257 93.1358 105.448 93.5957 105.449 94.0755Z",
    fill: "#FFD88D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.332 95.9021C110.335 95.9021 111.149 95.0911 111.149 94.0907C111.149 93.0903 110.335 92.2793 109.332 92.2793C108.329 92.2793 107.516 93.0903 107.516 94.0907C107.516 95.0911 108.329 95.9021 109.332 95.9021Z",
    fill: "#1EB89C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.949 144.783H103.263C102.205 144.783 101.348 145.637 101.348 146.689V174.242C101.348 175.294 102.205 176.148 103.263 176.148H130.949C132.007 176.148 132.865 175.294 132.865 174.242V146.689C132.865 145.637 132.007 144.783 130.949 144.783Z",
    fill: "#F2AE43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M128.814 148.881H105.398V172.05H128.814V148.881Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M110.148 163.119H107.789V169.137H110.148V163.119Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M110.148 163.119H107.789V172.047H110.148V163.119Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.214 158.9H111.855V167.759H114.214V158.9Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.214 158.9H111.855V172.045H114.214V158.9Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M118.284 161.494H115.926V168.605H118.284V161.494Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M118.284 161.494H115.926V172.045H118.284V161.494Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M122.355 157.857H119.996V167.425H122.355V157.857Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M122.355 157.857H119.996V172.05H122.355V157.857Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M126.423 152.291H124.064V165.606H126.423V152.291Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M126.423 152.291H124.064V172.049H126.423V152.291Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.287 168.787H137.072C135.956 168.787 135.051 169.688 135.051 170.799V199.872C135.051 200.983 135.956 201.884 137.072 201.884H166.287C167.403 201.884 168.308 200.983 168.308 199.872V170.799C168.308 169.688 167.403 168.787 166.287 168.787Z",
    fill: "#79A2FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M162.449 187.073C163.414 181.157 159.378 175.583 153.433 174.623C147.489 173.663 141.888 177.68 140.923 183.595C139.958 189.511 143.995 195.085 149.939 196.045C155.883 197.006 161.484 192.988 162.449 187.073Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M151.673 185.334L162.401 187.358C162.014 189.381 161.058 191.252 159.642 192.754C158.227 194.255 156.412 195.325 154.409 195.839C152.405 196.352 150.296 196.288 148.328 195.653C146.36 195.019 144.614 193.84 143.294 192.255C141.974 190.67 141.134 188.744 140.873 186.702C140.611 184.66 140.939 182.586 141.817 180.722C142.696 178.858 144.089 177.281 145.834 176.176C147.579 175.07 149.604 174.482 151.673 174.479V185.334Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M151.67 185.334V196.186C148.815 196.125 146.097 194.954 144.101 192.921C142.104 190.889 140.988 188.159 140.992 185.317C140.996 182.476 142.12 179.748 144.122 177.722C146.124 175.695 148.845 174.531 151.7 174.479L151.67 185.334Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M151.672 185.331L145.926 176.106C146.778 175.578 147.702 175.171 148.668 174.898C149.633 174.619 150.633 174.476 151.637 174.471L151.672 185.331Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242.862 111.721H178.823C177.982 111.721 177.301 112.261 177.301 112.928V201.668C177.301 202.335 177.982 202.876 178.823 202.876H242.862C243.703 202.876 244.384 202.335 244.384 201.668V112.928C244.384 112.261 243.703 111.721 242.862 111.721Z",
    fill: "#B7B7FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.492 123.268H181.855V124.629H194.492V123.268Z",
    fill: "#EBEBFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.492 126.326H181.855V127.687H194.492V126.326Z",
    fill: "#EBEBFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M239.488 123.268H226.852V124.629H239.488V123.268Z",
    fill: "#EBEBFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.932 116.979H203.295V118.34H215.932V116.979Z",
    fill: "#EBEBFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 114.604H181.855V115.965H239.489V114.604Z",
    fill: "#EBEBFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M239.484 130.564H188.281V131.926H239.484V130.564Z",
    fill: "#EBEBFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 133.283H181.855V134.644H239.489V133.283Z",
    fill: "#EBEBFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 136.006H181.855V137.367H239.489V136.006Z",
    fill: "#EBEBFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 138.721H181.855V140.082H239.489V138.721Z",
    fill: "#EBEBFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M233.058 141.439H181.855V142.801H233.058V141.439Z",
    fill: "#EBEBFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.484 146.377H188.281V147.738H239.484V146.377Z",
    fill: "#EBEBFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 149.092H181.855V150.453H239.489V149.092Z",
    fill: "#EBEBFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 151.803H181.855V153.164H239.489V151.803Z",
    fill: "#EBEBFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 154.529H181.855V155.891H239.489V154.529Z",
    fill: "#EBEBFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.058 157.244H181.855V158.605H233.058V157.244Z",
    fill: "#EBEBFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M239.484 162.182H188.281V163.543H239.484V162.182Z",
    fill: "#EBEBFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 164.893H181.855V166.254H239.489V164.893Z",
    fill: "#EBEBFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 167.619H181.855V168.98H239.489V167.619Z",
    fill: "#EBEBFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 170.326H181.855V171.687H239.489V170.326Z",
    fill: "#EBEBFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M233.058 173.049H181.855V174.41H233.058V173.049Z",
    fill: "#EBEBFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M239.484 178.494H188.281V179.855H239.484V178.494Z",
    fill: "#EBEBFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 181.213H181.855V182.574H239.489V181.213Z",
    fill: "#EBEBFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 183.928H181.855V185.289H239.489V183.928Z",
    fill: "#EBEBFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M239.489 186.65H181.855V188.012H239.489V186.65Z",
    fill: "#EBEBFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.058 189.369H181.855V190.73H233.058V189.369Z",
    fill: "#EBEBFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M239.488 197.201H226.852V198.562H239.488V197.201Z",
    fill: "#EBEBFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M242.935 180.588L249.346 185.377L251.058 182.834L244.814 178.116L250.034 175.676L232.851 171.81L242.092 186.566L242.935 180.588Z",
    fill: "#242323"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M236.508 169.489V165.229",
    stroke: "black",
    strokeWidth: 0.608004,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.924 170.33L229.191 167.057",
    stroke: "black",
    strokeWidth: 0.608004,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M231.005 173.75L226.754 174.123",
    stroke: "black",
    strokeWidth: 0.608004,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyOrg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyOrg.88e89ae1.svg";
export { ForwardRef as ReactComponent };